import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function MoveFillIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M16 2a7 7 0 0 1 7 7v6a7 7 0 0 1-7 7h-4a7 7 0 0 1-7-7V9a7 7 0 0 1 7-7zm-2.293 6.293a1 1 0 1 0-1.414 1.414L14.586 12l-2.293 2.293a1 1 0 1 0 1.414 1.414l3-3a1 1 0 0 0 0-1.414zM2.995 4.51a.75.75 0 0 1 .684 1.055A9 9 0 0 0 3 9v6a9 9 0 0 0 .679 3.435.747.747 0 0 1-1.275.763L2.4 19.2A6.97 6.97 0 0 1 1 15V9c0-1.576.521-3.03 1.4-4.2l.004.002a.75.75 0 0 1 .591-.292" />
    </Icon>
  );
}

MoveFillIcon.displayName = 'MoveFillIcon';
